import { useFormikContext } from 'formik'
import type { ReactElement } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Prompt } from 'react-router-dom'

function FormDirtyPrompt(props): ReactElement {
  const { t } = useTranslation()
  const { dirty, submitCount } = useFormikContext()

  return (
    <Prompt
      when={dirty && submitCount === 0 && !props.isDeleting}
      message={t(
        'form_dirty_prompt',
        'Are you sure you want to leave? You have unsaved changes.',
      )}
    />
  )
}

export default FormDirtyPrompt
